import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

type HouseInputProps = FieldControllerProps<'house', string | null> & ClassNameProp;

export const HouseInput = (props: HouseInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: 20,
   });

   return (
      <TextInput
         testId={props.name}
         label={commonTranslationKeys.addressData.houseNumberAbbreviation}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
